import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Button } from '@src/components/ui/button/button';
import { cn } from '@src/utils/ui';
import { Form } from '@src/components/ui/react-hook-form/form/form';
import { useAcceptTermsAndConditions } from './api/users';
import { termsAndAgreementSchemaValidator } from '@src/modules/user/schemas/User';
import { Checkbox } from '@src/components/ui/react-hook-form/checkbox/checkbox';
import { useFormContext } from 'react-hook-form';

export const TcppModal = ({ open, onClose, onShowSmsSubscription }) => {
    const handleClose = (_event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            onClose(_event);
        }
    };
    const acceptCallback = () => {
        onShowSmsSubscription();
        onClose();
    };
    const { mutate: acceptTermsAndConditions } = useAcceptTermsAndConditions();
    const handleAccept = values => {
        acceptTermsAndConditions(values, {
            onSuccess: () => {
                acceptCallback();
            },
            onError: error => {
                console.error('Error accepting terms and conditions:', error);
            }
        });
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            <Form
                className='tw-space-y-[16px]'
                onSubmit={handleAccept}
                validator={{ schema: termsAndAgreementSchemaValidator }}
            >
                <TcppModalContent className='tw-text-[16px]' />
            </Form>
        </Dialog>
    );
};

const PrivacyPolicyLabel = () => {
    return (
        <span className='tw-font-normal'>
            I have read and agreed to the{' '}
            <a
                href='https://www.bcaa.com/Legal/Marketplace-Privacy'
                target='_blank'
                className='tw-text-primary-500 hover:tw-font-medium hover:tw-text-primary-500'
            >
                Privacy Policy
            </a>
        </span>
    );
};
const TermsAndConditionsLabel = () => {
    return (
        <span className='tw-font-normal'>
            I have read and agreed to{' '}
            <a
                href='https://www.bcaa.com/Legal/Task-Marketplace-Terms'
                target='_blank'
                className='tw-text-primary-500 hover:tw-font-medium hover:tw-text-primary-500'
            >
                BCAA Task Marketplace Terms and Conditions.
            </a>
        </span>
    );
};

const TcppModalContent = () => {
    const {
        formState: { isValid }
    } = useFormContext();

    return (
        <>
            <DialogContent>
                <div className='tw-flex tw-flex-col tw-gap-[16px] tw-text-bcaa-grey-900 tw-text-[16px]'>
                    <h6 className='tw-font-medium tw-text-[20px]'>Welcome to BCAA Task Marketplace</h6>
                    <p>Please read and agree to the following before continuing.</p>
                    <div className='tw-flex tw-flex-col tw-gap-[2px]'>
                        <div className='tw-flex tw-gap-[8px] tw-items-start'>
                            <Checkbox
                                className='!tw-items-start'
                                checkBoxProps={{ size: 'small' }}
                                name='termsAndCondition'
                                value='I have read and agreed to BCAA Task Marketplace’s terms and conditions'
                                label={<TermsAndConditionsLabel />}
                            />
                        </div>

                        <div className='tw-flex tw-gap-[8px] tw-items-start'>
                            <Checkbox
                                className='!tw-items-start'
                                checkBoxProps={{ size: 'small' }}
                                value='I have read and agreed to the Privacy Policy'
                                name='privacyAndPolicy'
                                label={<PrivacyPolicyLabel />}
                            />
                        </div>

                        <div className='tw-flex tw-gap-[8px] tw-items-start'>
                            <Checkbox
                                className='!tw-items-start'
                                checkBoxProps={{ size: 'small' }}
                                value='I have read and agreed to the Service Quality Waiver'
                                name='serviceQualityWaiver'
                                label='I understand that BCAA is not responsible or liable for the services provided, including the quality of the work performed. Taskers are not endorsed or vetted by BCAA.'
                            />
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    className={cn('tw-p-[8px] tw-text-[14px] tw-w-full')}
                    autoFocus
                    variant='contained'
                    type='submit'
                    loadingPosition='start'
                    disabled={!isValid}
                >
                    Accept
                </Button>
            </DialogActions>
        </>
    );
};

TcppModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onShowSmsSubscription: PropTypes.func.isRequired
};
